import { render, staticRenderFns } from "./jurisdiction-set.vue?vue&type=template&id=1ec46473&scoped=true&"
import script from "./jurisdiction-set.vue?vue&type=script&lang=js&"
export * from "./jurisdiction-set.vue?vue&type=script&lang=js&"
import style0 from "./jurisdiction-set.vue?vue&type=style&index=0&id=1ec46473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec46473",
  null
  
)

export default component.exports